import { render } from "./FooterService.vue?vue&type=template&id=db60fdc8&scoped=true"
import script from "./FooterService.vue?vue&type=script&lang=js"
export * from "./FooterService.vue?vue&type=script&lang=js"

import "./FooterService.vue?vue&type=style&index=0&id=db60fdc8&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db60fdc8"]])

export default __exports__